import * as React from 'react';
import c from 'classnames';
import styles from '../buttonswitch/ButtonSwitch.css';
import * as ReactGA from 'react-ga';
import { documentSetCookie } from '../../cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  selectItemsView,
  changeListViewAction,
} from '../../ducks';
import { useDispatch, useSelector } from 'react-redux';
import {SETTINGSMENU} from '../../lib/labels';

const menuViewSelectionGAEvent = label => ReactGA.event({
  category: 'Menu',
  action: 'ViewSelection',
  label: label,
});

export const SettingsMenuViewButton = () => {
  const currentView = useSelector(selectItemsView);
  const dispatch = useDispatch();
  const view = ['cards', 'list'];
  return(
    <div className={styles.button_switch}>
      {(view.map((item, index) => (
        <label className={c(styles.multi_switcher, {[styles.checked]: item === currentView})}
          key={item + index}>
          <input type="radio" name="filterView" checked={item === currentView}
            onChange={() => {
              documentSetCookie('filterView', item);
              dispatch(changeListViewAction(item));
              menuViewSelectionGAEvent(`switch-to-${item}`);
            }}/>

          <div className={styles.checker}></div>
          <FontAwesomeIcon icon={item === 'list' ? ['fas', 'th-list'] : ['fas', 'th-large']} size="lg" />
          {item==='list' ?  SETTINGSMENU.VIEW.LIST :  SETTINGSMENU.VIEW.CARDS}
        </label>
      )))}
    </div>
  );
};


